import { HttpClient } from '../../httpClient'

type CreateBoardPresentationParams = {
  boardId: string
}

type CreatePresentationResponse = {
  data: {
    id: string
    type: 'presentation'
    attributes: {
      created_at: string
      is_processing: boolean
      lock_content: boolean
      subtitle?: string
      title: string
      updated_at: string
      use_background: boolean
    }
    links: {
      legacy_request: string
    }
    relationships: {
      workspace: {
        data: { id: string; type: 'workspace' }
      }
    }
  }
}

export function createBoardPresentation({
  params,
}: {
  params: CreateBoardPresentationParams
}): Promise<CreatePresentationResponse> {
  const url = new URL(
    `/presentations/from_board/${params.boardId}/`,
    window.location.origin
  )

  return HttpClient()
    .post<CreatePresentationResponse>(url.toString())
    .then((res) => res.data)
}
